import { factory } from '@repo-level/core-front';

export interface Prize {
  id: number;
  stuff: string;
  awardPlace: number;
  nickname: string | null;
  wagerMultiplier: number;
  moneyBudgetPercent: number;
  moneyAward: string;
  moneyAwardCents: number;
  chargeableCompPointsPercent: number;
  persistentCompPointsPercent: number;
  persistentCompPoints: number;
  chargeableCompPoints: number;
  freespinsCount: number;
}

export interface TopPlayer {
  tournamentId: number;
  nickname: string;
  userConfirmed: boolean | null;
  bets: string;
  betCents: number;
  wins: string;
  winCents: number;
  rate: number;
  gamesTaken: number;
  awardPlace: number | null;
  points: number;
  awardPlaceInTeam: number | null;
  tournamentTeamId: number | null;
}

export interface TournamentBackend {
  id: number;
  title: string;
  inProgress: boolean;
  userConfirmationRequired: boolean;
  frontendIdentifier: string;
  strategy: string;
  currencies: string[];
  gameCategoryIdentity: string;
  startAt: string;
  endAt: string;
  finishedAt: null;
  currency: string;
  moneyBudget: string;
  moneyBudgetCents: number;
  chargeableCompPointsBudget: number;
  persistentCompPointsBudget: number;
  prizes: Prize[];
  topPlayers: TopPlayer[];
  chargeableCompPointsPrizePool: number;
  persistentCompPointsPrizePool: number;
  moneyPrizePool: string;
  moneyPrizePoolCents: number;
  gamesTakenLimit: null;
  groupIds: number[];
}

export const tournamentsBackend = factory(
  (r) => () => r<TournamentBackend[]>('get', 'tournaments')
);

export const tournamentBackend = factory(
  (r) => (id: string) => r<TournamentBackend>('get', `tournaments/${id}`)
);

export const userTournamentStatus = factory(
  (r) => () => r<TopPlayer[]>('get', '/tournaments/statuses')
);
